module.exports = __webpack_public_path__ + "img/nav-measuring.c4522f3a.svg";